import { apiManager } from "../api-manager";

export const readHelpdeskChat = async (id: string) => {
  const res = await apiManager.post<string>("/helpdesk/read-message", {
    complaintId: id,
    currentUserType: "admin",
  });
  return res;
};
